import { Typography } from "@mui/material";

const Unauthorized = () => {
  return <Typography>Unauthorized</Typography>;
};

export default Unauthorized;
